import { useRef } from "react";
import { Link } from "react-router-dom";

import { useScrollReveal } from "../../../hooks/useScrollReveal";
import "./Who01.css";

import Button01 from "../../core/Button01";
import PathBackground01 from "../../core/PathBackground01";
import RivePlayer from "../../extras/RivePlayer01";

function Who01() {
  const { ref, isVisible } = useScrollReveal();
  const whoTrackRef = useRef(null);

  return (
    <div
      ref={(el) => {
        ref.current = el;
        whoTrackRef.current = el;
      }}
      className={`Who01 section section-reveal ${isVisible ? "section--visible" : ""}`}
      id="Who01"
    >
      <PathBackground01
        trackRef={whoTrackRef}
        className="Who01-pathBg"
        markerCount={4}
        trackMode="section-progress"
      />
      <div className="container">
        <div className="intro"></div>
        <div className="Who01-box">
          <div className="Who01-left">
            <h2>Who We Represent?</h2>
            <p>
              <span>We do not accept every application.</span> Built for
              creators who value discretion, protection, and a polished digital
              presence. We represent creators who want their content, identity,
              and brand handled with the care they deserve.
            </p>
            <h3>
              A smarter way to protect your content. Limited invitations remain
              available this quarter.
            </h3>

            <Button01 />
          </div>

          <div className="Who01-right">
            <RivePlayer src="/rive/creators.riv" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Who01;
